var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4851 20.1536L13.2231 13.8916C12.7231 14.3176 12.1481 14.6472 11.4981 14.8806C10.8481 15.1139 10.1948 15.2306 9.53811 15.2306C7.93677 15.2306 6.58144 14.6762 5.47211 13.5676C4.36277 12.4589 3.80811 11.1039 3.80811 9.50256C3.80811 7.90122 4.36211 6.54556 5.47011 5.43556C6.57811 4.32556 7.93277 3.76989 9.53411 3.76856C11.1354 3.76722 12.4914 4.32189 13.6021 5.43256C14.7128 6.54322 15.2681 7.89889 15.2681 9.49956C15.2681 10.1942 15.1451 10.8666 14.8991 11.5166C14.6531 12.1666 14.3298 12.7226 13.9291 13.1846L20.1911 19.4456L19.4851 20.1536ZM9.5391 14.2296C10.8658 14.2296 11.9858 13.7729 12.8991 12.8596C13.8124 11.9462 14.2691 10.8259 14.2691 9.49856C14.2691 8.17122 13.8124 7.05122 12.8991 6.13856C11.9858 5.22589 10.8658 4.76922 9.5391 4.76856C8.21244 4.76789 7.09211 5.22456 6.17811 6.13856C5.26411 7.05256 4.80744 8.17256 4.80811 9.49856C4.80877 10.8246 5.26544 11.9446 6.17811 12.8586C7.09077 13.7726 8.21077 14.2292 9.53811 14.2286M9.03811 11.8836V9.99956H7.15511V8.99956H9.04011V7.11556H10.0401V8.99956H11.9241V9.99956H10.0401V11.8846L9.03811 11.8836Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.98c7f1f7ceae0d943c73909a045f17ad.svg";
export { ForwardRef as ReactComponent };